import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const breadcrumbMap: Record<string, BreadcrumbItem[]> = {
  '/': [{ label: '首页' }],
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathname = location.pathname;

  let items: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

  if (pathname.startsWith('/category/')) {
    items.push({ label: '漫画分类' });
  } else if (pathname.startsWith('/article/')) {
    items.push({ label: '使用教程' });
  } else if (pathname === '/about') {
    items.push({ label: '关于我们' });
  }

  if (pathname === '/') return null;

  return (
    <nav aria-label="面包屑导航" className="max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-2">
      <ol className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            )}
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}